var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileBlueQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_message_white_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.395,
    height: 25.681,
    viewBox: "0 0 32.395 25.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2f67a7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171809",
    "data-name": "\\uADF8\\uB8F9 171809",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_37",
    "data-name": "\\uD569\\uCE58\\uAE30 37",
    className: "cls-1",
    d: "M0,25.681V13.542q0-.033,0-.071v-.342H.006C.082,10.649,1.013,1.728,10.4,0a32.973,32.973,0,0,1,1.466,4.107s-6.142.586-5.43,9.022h6.338V25.681Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_38",
    "data-name": "\\uD569\\uCE58\\uAE30 38",
    className: "cls-1",
    d: "M0,25.681V13.542q0-.033,0-.071v-.342H.006C.082,10.649,1.013,1.728,10.4,0a32.973,32.973,0,0,1,1.466,4.107s-6.142.586-5.43,9.022h6.338V25.681Z",
    transform: "translate(19.615)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBlueQuotes);
export default __webpack_public_path__ + "static/media/mobileBlueQuotes.08c2ce92c918794b703e7e56bc78dbdc.svg";
export { ForwardRef as ReactComponent };